import { TabItemProps } from './model';
import { View } from './view';

export const TabItem = (props: TabItemProps) => {
    const { onClick, index, currentTabIndex } = props;

    return View({ ...props, onClick: () => onClick(index), isActive: index === currentTabIndex });
};
